var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.classes,
    {
      'raised-bottom': _vm.viewport === 'mobile' && _vm.isPdpPage,
      'chrome-mobile': _vm.isChromeMobile,
    },
  ],attrs:{"data-preload":[_vm.$options.name]}},[_c('div',{staticClass:"inner"},[_c('Toast')],1),_vm._v(" "),_c('CookiesMain')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }